import Content from "../../help/serial-unit-trace.mdx";

export function SerialUnitTraceHelpPage() {
  return <Content />;
}
